import React from 'react';
import { useAds } from './AdProvider';

export default function AdBanner({ placement }) {
  const { ads } = useAds();
  const ad = ads[placement];
  if (!ad || !ad.html_content) return null;
  return (
    <div className={`ad-banner ad-banner-${placement}`}>
      <div dangerouslySetInnerHTML={{ __html: ad.html_content }} />
    </div>
  );
}
